"use strict";

var _UnAuthedUserScreen;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useAuth } from '@autoguru/auth';
import { PageLoading } from '@autoguru/components';
import { ContainedLayout } from '@autoguru/layout';
import { AsyncBoundary } from '@autoguru/suspense';
import { lazy, useEffect } from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { loggedInDashboardUrl } from '~/src/pages';
import { jsx as _jsx } from "react/jsx-runtime";
const UnAuthedUserScreen = /*#__PURE__*/lazy(async () => import('../../features/unauthed-in-user-screen/UnAuthedUserScreen'));
const Landing = () => {
  const {
    slug
  } = useParams();
  const {
    isAuthenticated
  } = useAuth();
  useEffect(() => {
    if (isAuthenticated) window.location.replace(generatePath(loggedInDashboardUrl, {
      slug: slug
    }).replace('https:/mygarage', 'https://mygarage'));
  }, [isAuthenticated, slug]);
  return /*#__PURE__*/_jsx(ContainedLayout, {
    children: /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: PageLoading,
      children: isAuthenticated ? null : _UnAuthedUserScreen || (_UnAuthedUserScreen = /*#__PURE__*/_jsx(UnAuthedUserScreen, {}))
    })
  });
};
export default Landing;